import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "@app/view/home/home.component";
import { SharedModule } from "@app/view/shared";
import { SetupModule } from "@app/view/setup/setup.module";
import { SharedMaterialModule } from "@app/view/shared/shared-material.module";
import { RegistrationComponent } from "@app/view/registration/registration.component";
import { AboutComponent } from "@app/view/about/about.component";
import { PermissionDeniedComponent } from "@app/view/permission-denied/permission-denied.component";
import { StatsComponent } from "@app/view/stats/stats.component";
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    data: { title: "scheduler.menu.home" }
  },
  {
    path: "registration",
    component: RegistrationComponent,
    data: { title: "scheduler.menu.register" },
    canActivate: [MsalGuard]
  },
  {
    path: "about",
    component: AboutComponent,
    data: { title: "scheduler.about.page" }
  },
  {
    path: "denied",
    component: PermissionDeniedComponent,
    data: { title: "Permission Denied" }
  },
  {
    path: "stats",
    component: StatsComponent,
    data: { title: "Solver Stats" }
  }
];

@NgModule({
  imports: [
    SharedModule,
    SharedMaterialModule,
    SetupModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      enableTracing: false,
      onSameUrlNavigation: "ignore" // 'always'
    }),
    HomeComponent,
    StatsComponent
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
